import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import Graph from "react-vis-network-graph";
import { IGraphModel } from "../../models/SharedModel";

interface INodesComponentProps {
  graph: IGraphModel | null
}

const NodesComponent = (props: INodesComponentProps) => {
  const { graph } = props

  // default styling
  const defaultNodeStyles = {
    borderWidth: 1,
    borderWidthSelected: 2,
    color: {
      border: "#2B7CE9",
      background: "#97C2FC",
      highlight: {
        border: "#2B7CE9",
        background: "#D2E5FF",
      },
      hover: {
        border: "#2B7CE9",
        background: "#D2E5FF",
      },
    },
    opacity: 1,
    font: {
      color: "#444",
    },
    shape: "box",
  };
  
  const defaultEdgeStyles = {
    color: {
      color: "#848484",
      highlight: "#848484",
      hover: "#848484",
      inherit: "from",
      opacity: 1.0,
    },
    shadow: {
      enabled: false,
      color: "rgba(0,0,0,0.5)",
      size: 10,
      x: 5,
      y: 5,
    },
    width: 1,
  };

  // graph settings
  const options = {
    layout: {
      hierarchical: false,
    },
    nodes: defaultNodeStyles,
    edges: defaultEdgeStyles,
    height: "500px",
    physics: {
      enabled: false
    }
  };

  const getGraph = useCallback(() => {
    return graph ? (
      <Graph graph={graph} options={options} />
    ) : (
      <div className="not-found">Please setup the ontology</div>
    );
  }, [graph]);

  return (
    <div className="nodes-main">{getGraph()}</div>
  );
};

export default NodesComponent;
